import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/assets/styles/tailwind.css';
import '@/assets/styles/index.scss';
import '@/assets/styles/style.css';
import '@/assets/styles/style.scss';
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'
import { init } from './helpers/init';

if (process.env.VUE_APP_MODE === 'production') {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  console.log = () => {};
}

init(store, router);
createApp(App).use(store).use(router).use(VueToast).mount('#app');
